import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { INgxGridResult, INgxGridFilter, INgxGridInstance, GridCustomTemplate } from 'ngx-primeng-grid';

import { BaseComponent } from '../../../core/_base/base';
import { INgxManageLayout, INgxManageLayoutAction } from '../../models/ngx-manage-layout.model';
import { IBreadcrumb } from '../../../ngx-wrapper-shared/models/breadcrumb';

@Component({
  selector: 'ngx-manage-layout',
  templateUrl: './ngx-manage-layout.component.html',
  styleUrls: ['./ngx-manage-layout.component.scss']
})
export class NgxManageLayoutComponent extends BaseComponent implements OnInit, AfterContentInit {

  // templates
  @ContentChildren(GridCustomTemplate) templates: QueryList<GridCustomTemplate>;
  // store layout
  _layout: INgxManageLayout = null;
  // result
  @Input() result: INgxGridResult<any>;
  // filter
  @Input() filter: INgxGridFilter;

  @Input() loading: boolean = false;

  @Input()
  set layout(value: INgxManageLayout) {
    if (value) {
      this._layout = value;
    }
  }

  // fire when user click on add
  @Output() onAction = new EventEmitter<INgxManageLayoutAction<any>>();
  // fire when filter chnaged
  @Output() onFilter = new EventEmitter<INgxGridFilter>();
  // search changed
  @Output() onSearch = new EventEmitter<string>();
  // breadcrumbs
  @Input() breadcrumbs: IBreadcrumb[] = [];
  // on row check
  @Output() onRowSelected = new EventEmitter<any>();

  // custom template
  customColumnTemplate: TemplateRef<any>;

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void { }

  ngAfterContentInit() {
    if (this.templates) {
      this.templates.forEach((item) => {
        switch (item.getType()) {
          case 'custom': {
            this.customColumnTemplate = item.template;
          } break;
        }
      });
    }
  }

  // handle when user click on add button
  handleAdd() {
    // check for dialog
    if (this._layout.setting.addOption.mode === 'modal') {
      // oprn 
      this.onAction.emit({ source: 'create' });
    } else if (this._layout.setting.addOption.mode === 'link') {
      // link
      this.router.navigateByUrl(this._layout.setting.addOption.link);
    } else if (this._layout.setting.addOption.mode === 'custom') {
      // for custom
      this.onAction.emit({ source: 'custom' });
    }
  }

  // handle action for table
  handleAction($instance: INgxGridInstance<any>) {
    this.onAction.emit({ source: 'table', instance: $instance });
  }

  // when table filter changed
  handleFilterChanged($filter: INgxGridFilter) {
    this.onFilter.emit($filter);
  }

  // handle search
  handleSearch(text: string) {
    this.onSearch.emit(text);
  }

  // handle when row selected by user
  handleOnRowSelected($event: any) {
    this.onRowSelected.emit($event);
  }

}
